import { Badge } from '@eventbrite/eds-badge';
import { Button } from '@eventbrite/eds-button';
import { CheckChunky } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { usePrevious } from 'react-use';
import { getUserCurrentLocation as getUserCurrentLocationAction } from '../../../../redux/actions/location';
import './DistanceFilterPanelHeaderContainer.scss';

interface DistanceFilterPanelHeaderProps {
    isUsingCurrentLocation?: boolean;
    isWaitingForLocation?: boolean;
    handleUseCurrentLocation?: () => void;
}

const DistanceFilterPanelHeaderContainerImpl: React.FunctionComponent<
    DistanceFilterPanelHeaderProps
> = (props) => {
    const [renderSuccessCheckMark, setRenderSuccessCheckmark] =
        React.useState(false);
    const previousIsUsingCurrent = usePrevious(props.isUsingCurrentLocation);

    React.useEffect(() => {
        if (previousIsUsingCurrent === false && props.isUsingCurrentLocation) {
            setRenderSuccessCheckmark(true);

            setTimeout(() => {
                setRenderSuccessCheckmark(false);
            }, 2000);
        }
    }, [previousIsUsingCurrent, props.isUsingCurrentLocation]);

    return (
        <div className="eds-text-bs filter-panel-header__distance-info">
            {props.isUsingCurrentLocation && !renderSuccessCheckMark
                ? gettext('from your current location')
                : gettext('from center of selected location')}
            {!props.isUsingCurrentLocation || renderSuccessCheckMark ? (
                <div>
                    <Button
                        __containerClassName="filter-panel-header__distance-info__cta"
                        isLoading={props.isWaitingForLocation}
                        style="link"
                        onClick={props.handleUseCurrentLocation}
                    >
                        {renderSuccessCheckMark ? (
                            <div className="filter-panel-header__distance-info__success-icon">
                                <Badge
                                    iconType={<CheckChunky />}
                                    bgColor="success"
                                />
                            </div>
                        ) : (
                            gettext('Use my current location')
                        )}
                    </Button>
                </div>
            ) : null}
        </div>
    );
};

const _mapStateToProps = (state: any) => {
    return {
        isUsingCurrentLocation: state.location.isUsingCurrentLocation,
        isWaitingForLocation: state.location.isWaitingForLocation,
    };
};

const _mapDispatchToProps = (dispatch: Function, ownProps: any) => ({
    handleUseCurrentLocation: () =>
        dispatch(getUserCurrentLocationAction(ownProps.history, false, true)),
});

export const DistanceFilterPanelHeaderContainer = withRouter(
    connect(
        _mapStateToProps,
        _mapDispatchToProps,
    )(DistanceFilterPanelHeaderContainerImpl),
);
